import React, { useState } from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import Chevron from 'assets/icons/chevron-right.svg';
import SearchIcon from 'assets/icons/searchIcon.svg';
import { SmartLink } from 'components/smart-link';
import Search from 'components/search/index';
import { classnames } from 'helpers/utils';
import { Modal } from 'components/modal';
import { IndexTypeEnum } from 'utils/enums';
import { MenuItem } from './menu-item/menuItem';
import * as styles from './header-desktop.module.scss';
import { HeaderItemType } from '../types';

const rightIndices = [{ name: IndexTypeEnum.authors }, { name: IndexTypeEnum.articles }];
const leftIndices = [{ name: IndexTypeEnum.tags }];

export const HeaderDesktop = (props: HeaderItemType) => {
  const { menuItems, button, popularTopics } = props;
  const [showMenu, onShowMenu] = useState(false);
  const [selected, onSelect] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const closeModal: () => void = () => {
    setOpenModal(false);
  };

  return (
    <div className={classnames(styles.header, styles.genericContainer)}>
      <nav className={styles.navbar}>
        <Link to="/">
          <StaticImage
            placeholder="blurred"
            layout="fixed"
            src="../../../assets/icons/logo.svg"
            alt="teeth talk girl logo"
          />
        </Link>
        {/* Is disabled because following aria guidelines, it did not specify that the tablist
        role needed to be focusable */}
        {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
        <div
          className={styles.headerItemsContainer}
          onMouseEnter={() => onShowMenu(true)}
          onMouseLeave={() => onShowMenu(false)}
          role="tablist"
        >
          {menuItems?.map((item, index) => (
            item.link
              ? (
                <div
                  className={styles.headerItem}
                  onMouseEnter={() => onSelect(index)}
                  key={item.id}
                >
                  <SmartLink
                    role="tab"
                    tabIndex={0}
                    aria-selected={(selected === index)}
                    className={classnames(styles.link)}
                    to={item.link}
                  >
                    {item.name}
                  </SmartLink>
                </div>
              ) : (
                <div
                  key={item.id}
                  role="tab"
                  tabIndex={0}
                  className={styles.headerItem}
                  onMouseEnter={() => onSelect(index)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onSelect(index);
                      onShowMenu(true);
                    }
                    if (e.key === 'Escape') {
                      onShowMenu(false);
                    }
                  }}
                  aria-selected={(selected === index)}
                >
                  {item.name}
                  <Chevron />
                  {showMenu
                    && (selected === index)
                    && <div className={styles.itemPointer} />}
                </div>
              )
          ))}
          {menuItems && !menuItems[selected].link && showMenu && (
            <div className={styles.menuItemsContainer}>
              <MenuItem menuItem={menuItems[selected]} />
            </div>
          )}
        </div>
        <div className={styles.buttonsContainer}>
          <button
            aria-label="Search button"
            className={styles.searchButton}
            onClick={() => setOpenModal(!openModal)}
          >
            <SearchIcon />
          </button>
          {openModal && (
          <Modal
            isOpen={openModal}
            onClose={closeModal}
            className={styles.modalContent}
          >
            <Search
              leftIndices={leftIndices}
              rightIndices={rightIndices}
              popularTopics={popularTopics}
            />
          </Modal>
          )}
          <SmartLink newTab to={button.link} className={styles.subscribeButton}>
            {button.name}
          </SmartLink>
        </div>
      </nav>
    </div>
  );
};
